import { useCallback } from "react";
import { GAME_FACT_HANDBALL_REDCARD, GAME_FACT_HANDBALL_YELLOWCARD, GAME_FACT_REDCARD, GAME_FACT_SOCCER_REDCARD, GAME_FACT_SOCCER_YELLOWCARD, GAME_FACT_YELLOWCARD } from "../../components/Live/gameFact/constants.js";

const hasPositiveNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0;
};

const getDefaultSoccerHolderNumber = (position) => {
  const displayPosition = position + 1;

  if (displayPosition === 4) return 6;
  if (displayPosition === 6) return 4;

  return displayPosition;
};


export const useFeuilleDeMatch = ({
    discipline, 
    match,
    matchData, 
    holdersLabel, 
    susbstitutesLabel, 
    setMatchData,
    teamPlayers
}) => {

    let nbPlayerOnField = 0

    switch(discipline){
        case 'soccer':
            nbPlayerOnField = 11
        break;
        case 'rugby':
            nbPlayerOnField = 15
        break;
        case 'handball':
            nbPlayerOnField = 7
        break;
        case 'basket':
            nbPlayerOnField = 5
        break;
        default:
            nbPlayerOnField = 11
    }

    // Helpers pour éviter les doublons de numéros EN SOCCER quand on génère un numéro
    const getUsedNumbers = (holders = [], subs = []) => {
    const set = new Set();
    holders.forEach(h => { if (h?.numero > 0) set.add(h.numero); });
    subs.forEach(s => { if (s?.numero > 0) set.add(s.numero); });
    return set;
    };

    // Choisit un numéro >0 non utilisé. preferred = tentative initiale (ex: idx+1)
    const pickUniqueNumber = (preferred, used, start = 1) => {
    let n = (preferred && preferred > 0) ? preferred : start;
    while (used.has(n)) n++;
    return n;
    };

    const handleSelectPlayer = useCallback((value, idx) => {
        // idx = position terrain (0..14 en rugby)
         console.log("handleSelectPlayer", value, idx)
        let newHolders = [...matchData[holdersLabel]];
        let newSubs = [...matchData[susbstitutesLabel]];

        const pInH = newHolders.find(h => h && h._id === value);
        const pInS = newSubs.find(s => s && s._id === value);

        // Numéro du joueur qui arrive SUR LE TERRAIN
        let numero;
        // if (discipline === 'rugby') {
        // numero = idx + 1; // numéro = poste
        // } else {
        const player = teamPlayers.find(p => p._id === value);

        if (pInH?.numero > 0) {
            // déjà sur le terrain : on garde son numéro
            numero = pInH.numero;
        } else 
        if (pInS?.numero > 0) {
            // vient du banc : on garde son numéro de banc (foot/hand/basket)
            numero = pInS.numero;
        }  else if (hasPositiveNumber(player?.number)) {
            // a un numéro de maillot valide : on le garde
            numero = player.number;
        } else {
            // ⬇️ joueur SANS numéro -> on GÉNÈRE
            if (discipline === 'soccer') {
            const used = getUsedNumbers(newHolders, newSubs);
            numero = pickUniqueNumber(getDefaultSoccerHolderNumber(idx), used, 1);
            } else {
            // hand/basket: fallback simple (comportement inchangé)
            numero = idx + 1;
            }
        }
        // }

        const existingHolder = newHolders.find(h => h && h.position === idx);
        const newHolder = { _id: value, numero, position: idx };

        if (!existingHolder) {
            // place le joueur
            newHolders.push(newHolder);
            // enlève son ancienne place
            if (pInH) newHolders[newHolders.indexOf(pInH)] = {};
            if (pInS) newSubs[newSubs.indexOf(pInS)] = {};
        } else {

            //on va switch les 2 numeros des postes : le newHolder prend le numéro du existingHolder et inversement
            //5
            let existingHolderNum = existingHolder?.numero;
            //17
            let newHolderNum = newHolder?.numero;
            newHolder.numero = existingHolderNum ? existingHolderNum : newHolderNum;
            existingHolder.numero = existingHolderNum ? newHolderNum : existingHolder.numero;

            //On va écraser ensuite checun des numéros dans le cas ou le player avait un number associé
            const playerNewHolder = teamPlayers.find(p => p._id === newHolder._id);
            const playerExistingHolder = teamPlayers.find(p => p._id === existingHolder._id);
            
            //On ne switch pas les numéros si au moins un de deux joueurs a un numéro de maillot défini
            if (playerNewHolder?.number > 0 || playerExistingHolder?.number > 0) {
                //on remet les numéros initiaux
                newHolder.numero = newHolderNum;
                existingHolder.numero = existingHolderNum;
            }

            //On écrase avec le number du player (numéro par défaut)
            if(playerNewHolder?.number > 0){
                newHolder.numero = playerNewHolder.number
            }
            if(playerExistingHolder?.number > 0){
                existingHolder.numero = playerExistingHolder.number
            }

            // swap avec le joueur déjà sur le poste
            newHolders[newHolders.indexOf(existingHolder)] = newHolder;

            // si le joueur qui arrive venait du terrain -> l'autre reprend SON ancien poste avec numéro recalculé (rugby)
            if (pInH) {
            const hOld = pInH.position;
            const replacement = {
                _id: existingHolder._id,
                numero: existingHolder.numero,
                position: hOld
            };
            newHolders[newHolders.indexOf(pInH)] = replacement;
            }

            // s'il venait du banc -> l'autre descend au banc à l'ANCIEN index du banc
            if (pInS) {
            const sOld = pInS.position;
            const replacement = {
                _id: existingHolder._id,
                numero: existingHolder.numero,
                position: sOld
            };
            newSubs[newSubs.indexOf(pInS)] = replacement;
            }
        }

        setMatchData(s => ({ ...s, [holdersLabel]: newHolders, [susbstitutesLabel]: newSubs }));
        }, [matchData, teamPlayers, nbPlayerOnField, discipline, holdersLabel, susbstitutesLabel]);


        
        //TODO ce qu'on peut faire : quand un joueur arrive sur le terrain, en étant substitute, on leur switch leurs numéros, et pas de terrain a terrain. ? a définir
        const handleSelectSub = useCallback((value, idx) => {

            //  console.log("handleSelectSub", value, idx)
          
            
            // idx = index banc (0 => n°16 en rugby)
            let newHolders = [...matchData[holdersLabel]];
            let newSubs = [...matchData[susbstitutesLabel]];

            const pInH = newHolders.find(h => h && h._id === value);
            const pInS = newSubs.find(s => s && s._id === value);

            // Numéro du joueur qui arrive SUR LE BANC
            let numero;
            // if (discipline === 'rugby') {
            // numero = idx>=nbPlayerOnField ? idx + 1 : nbPlayerOnField + idx + 1
            // } else {
                const player = teamPlayers.find(p => p._id === value);

                if (pInH?.numero > 0) {
                    // venait du terrain : il garde son numéro
                    numero = pInH.numero;
                } else if (pInS?.numero > 0) {
                    // déjà sur le banc ailleurs : il garde son numéro
                    // console.log('déjà sur le banc ailleurs : il garde son numéro: pInS numero', pInS)
                    numero = pInS.numero;
                } else if (player?.number > 0) {
                    // a un numéro de maillot : on le garde
                    // console.log('a un numéro de maillot : on le garde: player number', player)
                    numero = player.number;
                } else {
                    // console.log('pas de numéro : on génère')
                    // ⬇️ joueur SANS numéro -> on GÉNÈRE
                    if (discipline === 'soccer') {
                    const used = getUsedNumbers(newHolders, newSubs);
                    // on démarre à 12 (= nbOnField+1) pour rester cohérent avec un banc classique
                    numero = pickUniqueNumber(nbPlayerOnField + idx + 1, used, nbPlayerOnField + 1);
                    } else {
                    // hand/basket: fallback simple (comportement inchangé)
                    numero = nbPlayerOnField + idx + 1;
                    }
                }
            // }

            let existingSub = discipline === 'soccer' ? newSubs[idx] : newSubs.find(su => su && su.position === idx);
            const newSub = { _id: value, numero, position: idx };

            //TODO bloc probablement a supprimer suite a evol deux lignes au dessus / ajuster juste si null position
             if (!existingSub && newSubs[idx] && Object.keys(newSubs[idx]).length > 0 && newSubs[idx].position === null) {
                    // il y avait déjà quelqu'un à cet index mais avec une position nulle
                    // on le récupère pour le swap
                    existingSub = newSubs[idx];
                    //on va lui set la position de l'index
                    existingSub.position = idx;
                }

            // console.log("  -> numéro du joueur qu'on ajoute : ", numero);
            // console.log("  -> numéro du joueur qui prend la place du 1er : ", existingSub?.numero);

            if (!existingSub) {
                newSubs[idx] = newSub;
                if (pInH) newHolders[newHolders.indexOf(pInH)] = {};
                if (pInS) newSubs[newSubs.indexOf(pInS)] = {};
            } else {

                //on va switch les 2 numeros des postes : le newSub prend le numéro du existingSub et inversement
                //5
                let existingSubNum = existingSub?.numero;
                //17
                let newSubNum = newSub?.numero;
                newSub.numero = existingSubNum ? existingSubNum : newSubNum;
                existingSub.numero = existingSubNum ? newSubNum : existingSub.numero;

                //On va écraser ensuite checun des numéros dans le cas ou le player avait un number associé
                const playerNewSub = teamPlayers.find(p => p._id === newSub._id);
                const playerExistingSub = teamPlayers.find(p => p._id === existingSub._id);
                
                //On ne switch pas les numéros si au moins un de deux joueurs a un numéro de maillot défini
                if (playerNewSub?.number > 0 || playerExistingSub?.number > 0) {
                    //on remet les numéros initiaux
                    newSub.numero = newSubNum;
                    existingSub.numero = existingSubNum;
                }

                //On écrase avec le number du player (numéro par défaut)
                if(playerNewSub?.number > 0){
                    newSub.numero = playerNewSub.number
                }
                if(playerExistingSub?.number > 0){
                    existingSub.numero = playerExistingSub.number
                }

                // swap avec le joueur déjà sur ce slot de banc
                newSubs[newSubs.indexOf(existingSub)] = newSub;

                // si le joueur qui descendait venait du terrain -> il récupère SON ancien poste avec numéro recalculé (rugby)
                if (pInH) {
                const hOld = pInH.position;
                const replacement = {
                    _id: existingSub._id,
                    numero: existingSub.numero,
                    position: hOld
                };
                newHolders[newHolders.indexOf(pInH)] = replacement;
                }

                // s’il venait d’un autre slot du banc -> on garde sa position d’origine, numéro recalculé en rugby
                if (pInS) {
                const sOld = pInS.position;
                const replacement = {
                    _id: existingSub._id,
                    numero: existingSub.numero,
                    position: sOld
                };
                newSubs[newSubs.indexOf(pInS)] = replacement;
                }
            }

            setMatchData(s => ({ ...s, [holdersLabel]: newHolders, [susbstitutesLabel]: newSubs }));
            }, [matchData, teamPlayers, nbPlayerOnField, discipline, holdersLabel, susbstitutesLabel]);

    const displayCoachGamefact = (teamId) => {
            // Trouver les fais de jeu de coach de l'équipe : 
    
            const coachGamefacts = match.gameFacts.filter(g => g.detail.team === teamId && g.detail.player === 'coach')
    
            if(!coachGamefacts.length)
                return ""
    
            let gfDetails = "("
    
            gfDetails = coachGamefacts.reduce((acc, curr) => {
                if([GAME_FACT_YELLOWCARD, GAME_FACT_SOCCER_YELLOWCARD].includes(curr.type)){
                    return acc + "carton jaune"
                }
    
                if([GAME_FACT_REDCARD, GAME_FACT_SOCCER_REDCARD].includes(curr.type)){
                    return acc + "carton rouge"
                }
    
                if([GAME_FACT_HANDBALL_YELLOWCARD].includes(curr.type)){
                    return acc + "avertissement"
                }
    
                if([GAME_FACT_HANDBALL_REDCARD].includes(curr.type)){
                    return acc + "exclusion"
                }
    
            }, gfDetails)
    
            return gfDetails + ")"
        }

        return {handleSelectPlayer, handleSelectSub, displayCoachGamefact}

}